/**
 * Copyright 2022 Design Barn Inc.
 */

import * as React from 'react';

export const ChevronUp: React.FC = (): JSX.Element => (
  <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.66683 4.6665L4.00016 1.33317L7.3335 4.6665"
      stroke="#B8C2CC"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
